(function () {
    'use strict';

    wo$(function () {
        var page = wo$('#home');
        if (!page.length) return;

        var homeController = {
            init: function () {
                page.find('#lead-article').click(function () {
                    var url = wo$(this).attr('data-url');
                    location.href = url;
                });

                page.find('#popular-strip tr.hover-bg').click(function () {
                    var url = wo$(this).find('a').attr('href');
                    if (url) {
                        location.href = url;
                    }
                });

                WhistleOut.getAds('Tablets');
            }
        };

        homeController.init();
    });
})();
